export enum CountryCode {
  TAIWAN = "TW",
  JAPAN = "JP",
  KOREA = "KR",
  CHINA = "CN",
  HONG_KONG = "HK",
  MACAU = "MO",
  SINGAPORE = "SG",
  MALAYSIA = "MY",
  THAILAND = "TH",
  VIETNAM = "VN",
  PHILIPPINES = "PH",
  INDONESIA = "ID",
  UNITED_STATES = "US",
  CANADA = "CA",
  AUSTRALIA = "AU",
  NEW_ZEALAND = "NZ",
  UNITED_KINGDOM = "GB",
  GERMANY = "DE",
  FRANCE = "FR",
}

export const overseasCountryCodeOptions = [
  { label: "日本", value: CountryCode.JAPAN },
  { label: "韓國", value: CountryCode.KOREA },
  { label: "中國", value: CountryCode.CHINA },
  { label: "香港", value: CountryCode.HONG_KONG },
  { label: "澳門", value: CountryCode.MACAU },
  { label: "新加坡", value: CountryCode.SINGAPORE },
  { label: "馬來西亞", value: CountryCode.MALAYSIA },
  { label: "泰國", value: CountryCode.THAILAND },
  { label: "越南", value: CountryCode.VIETNAM },
  { label: "菲律賓", value: CountryCode.PHILIPPINES },
  { label: "印尼", value: CountryCode.INDONESIA },
  { label: "美國", value: CountryCode.UNITED_STATES },
  { label: "加拿大", value: CountryCode.CANADA },
  { label: "澳洲", value: CountryCode.AUSTRALIA },
  { label: "紐西蘭", value: CountryCode.NEW_ZEALAND },
  { label: "英國", value: CountryCode.UNITED_KINGDOM },
  { label: "德國", value: CountryCode.GERMANY },
  { label: "法國", value: CountryCode.FRANCE },
];

export enum AddressRegion {
  DOMESTIC = "DOMESTIC",
  OVERSEAS = "OVERSEAS",
}

export const addressRegionTypeOptions = [
  { label: "國內", value: AddressRegion.DOMESTIC },
  { label: "國外", value: AddressRegion.OVERSEAS },
];
